import { createStyles } from '@mui/styles'

const useStyles = () =>
  createStyles({
    backdrop: {
      zIndex: 1
    },
    container: {
      width: '100vw',
      height: '100vh',
      overflow: 'auto',
      alignText: 'center'
    },
    formLogin: {
      display: 'flex',
      'flex-direction': 'column !important',
      justifyContent: 'center'
    },
    leftContainer: {
      overflow: 'auto',
      height: '100vh',
      display: 'flex',
      'flex-direction': 'column !important',
      paddingLeft: 50,
      paddingRight: 50,
      borderRadius: 4
    },
    backgoundRightContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    centerContainer: {
      margin: 'auto'
    },
    logoContainer: {
      paddingBottom: 75
    },
    forgotPassword: {
      textDecoration: 'none',
      display: 'flex',
      textTransform: 'none'
    }
  })

export default useStyles
